export const VSC_SDK_LOADED_EVENT = 'vsc_sdk_loaded'
